import React, { forwardRef } from 'react';

// Components
import * as S from './Styled';

const Button = forwardRef(({ children, icon = null, ...rest }, ref) => (
  <S.Button {...rest} ref={ref}>
    <S.Inner>
      {icon}
      {children}
    </S.Inner>
  </S.Button>
));

export default Button;
